module.exports = __webpack_public_path__ + "static/img/manufactur-industry-h5-5.44bc9f6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/manufactur-industry-h5-5.png
// module id = 3M1j
// module chunks = 34